<div class="notification" [ngClass]="type()">
  @let clr = color();
  <div
    class="notification__stripe"
    [style.background-color]="clr ? (clr | preserveContrastColor) : null"
  ></div>
  <div class="notification__content--outer">
    <div class="notification__content--inner">
      @if (type() !== 'actionable') {
        <div class="notification__icon">
          <ng-container [ngTemplateOutlet]="iconTemplateRef() || defaultIcon" />
        </div>
      }
      <div class="notification__text">
        <ng-content />
      </div>
    </div>
    @let actionRef = actionTemplateRef();
    @if (actionRef) {
      <div class="notification__action">
        <ng-container *ngTemplateOutlet="actionRef" />
      </div>
    }
  </div>
  @if (type() === 'toast' || type() === 'toast-float') {
    <plugins-button
      class="notification__close"
      [text]="true"
      [ariaLabel]="dismissLabel() ?? ('notice.dismiss' | translate)"
      (clicked)="dismiss.emit()"
    >
      <icon-cancel [size]="16" />
    </plugins-button>
  }
</div>

<ng-template #defaultIcon>
  <icon-exclamation shape="circle" [size]="28" />
</ng-template>
